import { PushpinFilled, SafetyCertificateFilled, SafetyCertificateOutlined } from "@ant-design/icons";

export const NameView = (props:{titleStatus: string, strike?: boolean}) => {  

  return (
    <div className="title-box">
      <div style={{ margin: "1em 0 0 0", display: "flex", justifyContent: "flex-start" }}>
          {props.strike ?          
          <del style={{ color: 'darkred'}}>
             {props.titleStatus}  <PushpinFilled/>
          </del>
          :
          <span style={{ color: "slategrey" }}>
              {props.titleStatus}
          </span>          
          }
      </div>                
    </div>
  )
}
